/**
 * 站点配置文件
 * @description 统一管理站点级别的配置信息，包括品牌、联系方式、版权、备案等
 * @module config/v2/siteConfig
 *
 * 维护说明：
 * - 此配置文件作为单一数据源，供Footer、服务中心等组件引用
 * - 修改后需重新部署生效
 * - 未来可升级为API配置，使用此文件作为降级默认值
 */

import qrcodeCustomerService from '@/assets/images/common/qrcode-Customer Service.png'
import separatorLineSvg from '@/assets/images/common/separator-line.svg'
import mainLogoLightSvg from '@/assets/logo/main-logo-cn-light.svg'
import mainLogoDarkSvg from '@/assets/logo/main-logo-cn.svg'

/**
 * 站点配置
 */
export const siteConfig = {
  /**
   * 品牌信息
   */
  brand: {
    name: 'Mech3D',
    slogan: '专业的3D模型分享与众包任务平台',
    description: '为设计师、工程师和制造企业提供一站式解决方案',
  },

  /**
   * 联系信息
   */
  contact: {
    hotline: '400-123-4567',
    email: 'service@mech3d.com',
    address: '北京市朝阳区xxx大厦xxx层',
    workingHours: '周一至周五 9:00-18:00',
    wechat: 'Mech3D_Official',
    qq: '800888888',
  },

  /**
   * 版权信息
   */
  copyright: {
    year: new Date().getFullYear().toString(),
    company: 'Mech3D',
    rights: 'All rights reserved.版权所有',
  },

  /**
   * 备案信息
   */
  filing: {
    icp: '京ICP备 12445678号-1',
    security: '京公网安备11010802012345号',
    license: 'ICP经营许可证：京B2-xxxxx',
  },

  /**
   * 社交媒体二维码
   */
  socialMedia: [
    {
      key: 'customer-service',
      label: '平台客服',
      qrcode: qrcodeCustomerService,
    },
  ],

  /**
   * 静态资源
   */
  assets: {
    logo: mainLogoLightSvg,
    logoLight: mainLogoLightSvg,
    logoDark: mainLogoDarkSvg,
    separatorLine: separatorLineSvg,
  },
} as const

/**
 * 站点配置类型
 */
export type SiteConfig = typeof siteConfig
